import { ArrayField, JsonParseError, JsonParseErrorCode } from "sparkson";
import { Source } from "./Source";
import { Subtitle } from "./Subtitle";

export class VideoSources {
  constructor(
    @ArrayField("so", Source) public sources: Source[],
    @ArrayField("su", Subtitle, true) public subtitles: Subtitle[] = [],
  ) {
    if (!sources.length) {
      throw new JsonParseError("VideoSources must have at least one source", JsonParseErrorCode.VALIDATION_FAILED);
    }
  }
}
